// extracted by extract-css-chunks-webpack-plugin
module.exports = {"split-flap-price":"split-flap-price___VpBeZ","thousands":"thousands___SaPe8","millions":"millions___jDTsV"};